import { createReducer, on } from "@ngrx/store";
import { initialNotificationState, IRecipient } from "./notification.state";
import { NotificationActions } from "./notification.actions";
import { onLoadableLoad, onLoadableSuccess, onLoadableError, arrayToILoadableWrapperArray, toLoadableWrapper } from "../../models";
import { UserActions } from "../user/user.actions";
import { NEW_KEY_ID, removeItem, replaceItem } from "../common";

export const notificationReducer = createReducer(
    initialNotificationState,
    on(NotificationActions.loadRecipients, state => ({
        ...state,
        recipients: {
            ...onLoadableLoad(state.recipients),
            items: []
        }
    })),
    on(NotificationActions.loadRecipientsSuccess, (state, { recipients }) => ({
        ...state,
        recipients: {
            ...onLoadableSuccess(state.recipients),
            items: arrayToILoadableWrapperArray([...recipients].sort((a, b) => a.name.localeCompare(b.name)))
        }
    })),
    on(NotificationActions.loadRecipientsFailure, (state, { error }) => ({
        ...state,
        recipients: {
            ...onLoadableError(state.recipients, error),
            items: []
        }
    })),
    on(NotificationActions.sendNotification, state => ({
        ...state,
        notification: {
            ...onLoadableLoad(state.notification),
        }
    })),
    on(NotificationActions.sendNotificationSuccess, state => ({
        ...state,
        notification: {
            ...onLoadableSuccess(state.notification),
        }
    })),
    on(NotificationActions.sendNotificationFailure, (state, { error }) => ({
        ...state,
        notification: {
            ...onLoadableError(state.notification, error),
        }
    })),
    on(NotificationActions.createRecipient, (state, { recipient }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: [...state.recipients.items, onLoadableLoad(toLoadableWrapper({
                id: NEW_KEY_ID
            } as IRecipient))]
        }
    })),
    on(NotificationActions.createRecipientSuccess, (state, { recipient }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: [onLoadableSuccess(toLoadableWrapper(recipient)), ...removeItem(state.recipients.items, NEW_KEY_ID)]
        }
    })),
    on(NotificationActions.createRecipientFailure, (state, { recipient, error }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: [...state.recipients.items, onLoadableError(toLoadableWrapper({
                id: NEW_KEY_ID
            } as IRecipient), error)]
        }
    })),
    on(NotificationActions.updateRecipient, (state, { recipient }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: replaceItem(state.recipients.items, onLoadableLoad(state.recipients.items.find(e => e.id === recipient.id)!))
        }
    })),
    on(NotificationActions.updateRecipientSuccess, (state, { recipient }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: replaceItem(state.recipients.items, onLoadableSuccess(toLoadableWrapper(recipient)))
        }
    })),
    on(NotificationActions.updateRecipientFailure, (state, { recipient, error }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: replaceItem(state.recipients.items, onLoadableError(state.recipients.items.find(e => e.id === recipient.id)!, error))
        }
    })),
    on(NotificationActions.deleteRecipient, (state, { recipient }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: replaceItem(state.recipients.items, onLoadableLoad(toLoadableWrapper(recipient)))
        }
    })),
    on(NotificationActions.deleteRecipientSuccess, (state, { recipient }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: removeItem(state.recipients.items, recipient.id)
        }
    })),
    on(NotificationActions.deleteRecipientFailure, (state, { recipient, error }) => ({
        ...state,
        recipients: {
            ...state.recipients,
            items: replaceItem(state.recipients.items, onLoadableError(toLoadableWrapper(recipient), error))
        }
    })),
    on(UserActions.logout, _ => ({ ...initialNotificationState })),
)